module.exports = __webpack_public_path__ + "img/horizontal_6_7_4.1f456d34.png";